import { createContext, useContext, useState } from "react"

const ChatContext = createContext({
  pinnedMessages: [],
})

export const ChatProvider = ({ children }) => {
  const [isScheduleOpen, setIsScheduleOpen] = useState(false)
  const [isAssistanceOpen, setIsAssistanceOpen] = useState(false)
  const [openNewAssistance, setOpenNewAssistance] = useState(false)
  const [selectedSteps, setSelectedSteps] = useState(null)
  const [enableLinkComponent, setEnableLinkComponent] = useState(true)
  const [enabledIntegration, setEnabledIntegration] = useState({})
  const [pinnedMessages, setPinnedMessages] = useState([])
  const [pinnedMessagesQuestions, setPinnedMessagesQuestions] = useState([])
  const [fixedMessage, setFixedMessage] = useState([])
  const [evidenceId, setEvidenceId] = useState("")
  const [chatOpenScreen, setChatOpenScreen] = useState(false)
  const [chatId, setChatId] = useState(false)
  const [channelLoading, setChannelLoading] = useState(false)
  const [moreChannelLoading, setMoreChannelLoading] = useState(false)
  const [isLoadingMessages, setIsLoadingMessages] = useState(false)
  const [saveOnlyOneMessage, setSaveOnlyOneMessage] = useState(false)
  const [isLoadingTestimonial, setIsLoadingTestimonial] = useState(false)
  const [updatedMessages, setUpdatedMessages] = useState({})
  const [favoritedMessages, setFavoritedMessages] = useState([])


  const handleChangeSteps = (newSteps) => {
    setSelectedSteps(newSteps)
  }

  const handleOpenAssistanceStatus = (farmerDetails, withContext = false) => {
    setIsAssistanceOpen(pinnedMessages)
  }

  const handleOpenAssistance = () => {
    setOpenNewAssistance((prev) => !prev)
  }

  const handleCloseAssistanceStatus = () => {
    setIsAssistanceOpen(false)
  }

  const handleChangeLinkComponent = (newPinnedMessages) => {
    if (newPinnedMessages && newPinnedMessages.length) {
      setPinnedMessages(newPinnedMessages)
    }
  }

  const handleOpenSchedule = (message) => {
    setIsScheduleOpen(pinnedMessages)
  }

  const handleCloseSchedule = () => {
    setIsScheduleOpen(false)
  }

  const handleOpenChatScreen = (id) => {
    setChatOpenScreen((prev) => !prev)
    setChatId(id)
  }

  const addNewPinnedMessage = (newMessage, evidenceId = null) => {

    const messagesArray = Array.isArray(newMessage) ? newMessage : [newMessage]

    setPinnedMessages((curr) => {
      const combined = [...messagesArray, ...curr];

      const uniqueById = Array.from(
        new Map(combined.map((msg) => [msg?.id, msg])).values()
      );

      return uniqueById;
    })

    console.log("SDSD", newMessage)

    if (evidenceId) {
      setPinnedMessagesQuestions((curr) => {
        const key = `${evidenceId}-messages`
        const existingMessages = curr[key] || []

        const combined = [...existingMessages, ...messagesArray]

        const uniqueById = Array.from(
          new Map(combined.map((msg) => [msg?.id, msg])).values()
        )

        return {
          ...curr,
          [key]: uniqueById,
        }
      })
    }
  }

  const handleSaveOnlyOneMessage = () => {
    setSaveOnlyOneMessage(true)
  }

  const removePinnedMessage = (messageId, evidenceId = null) => {
    if (evidenceId) {
      setPinnedMessages((curr) => curr.filter((msg) => msg.id !== messageId))
      setPinnedMessagesQuestions((curr) => {
        const key = `${evidenceId}-messages`
        const filteredMessages = (curr[key] || []).filter((item) => item?.id !== messageId)

        return {
          ...curr,
          [key]: filteredMessages,
        }
      })
    } else {
      setPinnedMessages((curr) => curr.filter((msg) => msg.id !== messageId))
    }
  }

  const resetPinnedMessages = () => {
    setPinnedMessages([])
    //setPinnedMessagesQuestions([])
    setSaveOnlyOneMessage(false)
  }

  const resetPinnedMessagesQuestions = (evidenceId = null) => {
    if (evidenceId) {
      const key = `${evidenceId}-messages`

      setPinnedMessagesQuestions((curr) => {
        const newState = { ...curr }
        delete newState[key]
        return newState
      })

      setPinnedMessages([])
    } else {
      setPinnedMessages([])
      setPinnedMessagesQuestions({})
    }
  }


  return (
    <ChatContext.Provider
      value={{
        isScheduleOpen,
        isAssistanceOpen,
        handleOpenAssistanceStatus,
        handleCloseAssistanceStatus,
        handleOpenSchedule,
        handleCloseSchedule,
        handleChangeSteps,
        selectedSteps,
        addNewPinnedMessage,
        removePinnedMessage,
        pinnedMessages,
        handleChangeLinkComponent,
        enableLinkComponent,
        resetPinnedMessages,
        resetPinnedMessagesQuestions,
        fixedMessage,
        setFixedMessage,
        saveOnlyOneMessage,
        handleSaveOnlyOneMessage,
        pinnedMessagesQuestions,
        evidenceId,
        setEvidenceId,
        openNewAssistance,
        setOpenNewAssistance,
        handleOpenAssistance,
        handleOpenChatScreen,
        chatId,
        chatOpenScreen,
        channelLoading,
        setChannelLoading,
        moreChannelLoading,
        setMoreChannelLoading,
        isLoadingMessages,
        setIsLoadingMessages,
        updatedMessages,
        setUpdatedMessages,
        favoritedMessages,
        setFavoritedMessages,
        enabledIntegration,
        setEnabledIntegration,
        setIsLoadingTestimonial,
        isLoadingTestimonial
      }}>
      {children}
    </ChatContext.Provider>
  )
}

export const useChatContext = () => {
  return useContext(ChatContext)
}
